export function roomTheme(hex){
 const value=/^#[0-9a-f]{6}$/i.test(hex||'')?hex:'#6a827c';
 const rgb=[1,3,5].map(i=>parseInt(value.slice(i,i+2),16));
 const blend=(base,amount)=>'#'+rgb.map((c,i)=>Math.round(c*(1-amount)+base[i]*amount).toString(16).padStart(2,'0')).join('');
 return {accent:value,wall:blend([238,232,219],.92),sofa:blend([105,100,96],.28),rug:blend([223,211,186],.72),wood:blend([80,51,31],.88)};
}
export function neighbours(items,index){return items.slice(Math.max(0,index-2),Math.min(items.length,index+3));}
